import {Component, EventEmitter, Input, OnChanges, Output, ChangeDetectionStrategy} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatMenuModule} from '@angular/material/menu';
import {MatIconModule} from '@angular/material/icon';
import {SplitButtonItem} from './model/split-button.model';
import {MatTooltipModule} from '@angular/material/tooltip';
import {Severity} from '../../models/common/common.models';

@Component({
    selector: 'app-button',
    standalone: true,
    imports: [MatButtonModule, MatMenuModule, MatIconModule, MatTooltipModule],
    templateUrl: './button.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./button.component.scss'],
})
export class ButtonComponent implements OnChanges {
    @Input() label = '';
    @Input() tooltip?: string;
    @Input() faIcon?: string;
    @Input() color: Severity = 'primary';
    @Input() items: SplitButtonItem[] = [];
    @Input() disabled = false;
    @Input() styleClass: string;

    @Output() buttonClick = new EventEmitter<void>();

    public severity: 'btn--primary' | 'btn--outline-grey-color' | 'btn--danger' = 'btn--primary';

    ngOnChanges(): void {
        this.initSeverity();
    }

    private initSeverity() {
        switch (this.color) {
            case 'primary': {
                this.severity = 'btn--primary';
                break;
            }
            case 'danger': {
                this.severity = 'btn--danger';
                break;
            }
            case 'grey': {
                this.severity = 'btn--outline-grey-color';
                break;
            }
            default: {
                this.severity = 'btn--primary';
            }
        }
    }

    onPrimary() {
        if (!this.disabled) {
            this.buttonClick.emit();
        }
    }

    onItemClick(item: SplitButtonItem) {
        if (!item.disabled && item.action) {
            item.action();
        }
    }
}
